interface SidebarProto {
  name: string;
  title: string;
  routerLink: any[];
  icon?: string;
}

export class SidebarEntity implements SidebarProto {
  constructor(public name,
              public title,
              public routerLink,
              public icon?) {
  }
}
